import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './Scope.scss'

const Scope = props => {
	return (
		<div styleName="scope">
			<label>
				<input {...props} type="checkbox" styleName="input" />
				<span styleName={props.checked ? 'label-checked' : 'label'}>
					<strong>{props.value}</strong>
					<br />
					{props.label}
				</span>
			</label>
		</div>
	)
}
export default CSSModules(Scope, styles)



// WEBPACK FOOTER //
// ./src/components/Scope/Scope.js